import ConnectionService, { HttpMethod } from './connection.service';

export interface OAuthConsentResponse {
  redirectUri: string;
}

class OAuthConnection {
  public async consent(accountId: string, oauthParams: string): Promise<OAuthConsentResponse> {
    const data = { accountId, oauthParams };
    return await ConnectionService.fetch('../oauth/consent', HttpMethod.POST, data);
  }
}

export default new OAuthConnection();
